import { render } from "./OrgSettingsDropdownPanel.vue?vue&type=template&id=7123b762"
import script from "./OrgSettingsDropdownPanel.vue?vue&type=script&lang=js"
export * from "./OrgSettingsDropdownPanel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__